import { applyMiddleware, createStore } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'
// import logger from 'redux-logger'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from '../src/reducers'

const persistConfig = {
  key: 'root',
  storage,
  blacklist: ['savedData'],
}
const persistedReducer = persistReducer(persistConfig, rootReducer)
// export const store = createStore(persistedReducer, applyMiddleware(thunk, logger))
export const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)))
export const persistor = persistStore(store)
